import React, { useState } from 'react';
import './ResearchCell.css';
import Navbar from '../components/navbar';
import CTAButton from '../components/sticky-button';
import PageHeader from '../about/PageHeader';
import Footer from '../components/Footer';

const committeeData = {
  'A.Y. 2025-26': [
   { sr: 1, composition: "Chairman", name: "Dr. Pravin Gundalwar", designation: "Director" },
  { sr: 2, composition: "Convenor", name: "Dr. Padma Mishra", designation: "Associate Professor, TIMSCDR" },
  { sr: 3, composition: "Member – Finance & Infrastructure Committee", name: "Dr. Ashwini Renavikar", designation: "Professor & HOD MCA Integrated" },
  { sr: 4, composition: "Member – Research Program, Policy Development Committee", name: "Dr. Sonal Sharma", designation: "Associate Professor, TIMSCDR" },
  { sr: 5, composition: "Member – Collaboration & Consultancy Committee", name: "Ms. Kinjal Doshi", designation: "Assistant Professor, TIMSCDR" },
  { sr: 6, composition: "Member – IPR, Legal & Ethical Matters", name: "Mr. Shirshendu Maitra", designation: "Assistant Professor, TIMSCDR" },
  { sr: 7, composition: "Member – Product Development, Monitoring and Commercialization", name: "Dr. Shiksha Dubey", designation: "Assistant Professor, TIMSCDR" },
  { sr: 8, composition: "Member", name: "Prof. Sonu Gupta", designation: "Deputy Director" },
  { sr: 9, composition: "Member", name: "Dr. Seema Bansode Gokhe", designation: "Prof. & Head – PSM Dept., LTMMC & LTMGH" },
  { sr: 10, composition: "Member", name: "Mr. Dinesh Kumar Singh", designation: "TCS Innovation Lab" },
  { sr: 11, composition: "Member", name: "Dr. Mukesh Gupta", designation: "Founder – Le’Nest Hospital" },
  { sr: 12, composition: "Member", name: "Dr. Vilas Jadhav", designation: "Principal, KVK Kosbad, Palghar" },
  { sr: 13, composition: "Member", name: "Mr. Makrand Churi", designation: "Agro Consultant" }
  ],
  'A.Y. 2024-25': [
    { sr: 1, composition: 'Chairman', name: 'Dr. Vinita Gaikwad', designation: 'Director, TIMSCDR' },
    { sr: 2, composition: 'Convenor', name: 'Dr. Padma Mishra', designation: 'Associate Professor, TIMSCDR' },
    { sr: 3, composition: 'Member', name: 'Dr Ashwini Renavikar', designation: 'Professor, TIMSCDR' },
    { sr: 4, composition: 'Member', name: 'Dr. Sonal Sharma', designation: 'Associate Professor, TIMSCDR' },
    { sr: 5, composition: 'Member', name: 'Ms. Kinjal Doshi', designation: 'Assistant Professor, TIMSCDR' },
    { sr: 6, composition: 'Member', name: 'Mr. Shirshendu Maitra', designation: 'Assistant Professor, TIMSCDR' },
    { sr: 7, composition: 'Member', name: 'Dr. Shiksha Dubey', designation: 'Assistant Professor, TIMSCDR' },
    { sr: 8, composition: 'Member', name: 'Dr. Seema Bansode Gokhe', designation: 'Prof. & Head – PSM Dept., LTMMC & LTMGH' },
    { sr: 9, composition: 'Member', name: 'Mr. Dinesh Kumar Singh', designation: 'TCS Innovation Lab' },
    { sr: 10, composition: 'Member', name: 'Dr. Mukesh Gupta', designation: "Founder – Le'Nest Hospital" },
    { sr: 11, composition: 'Member', name: 'Dr. Vilas Jadhav', designation: 'Principal, KVK Kosbad, Palghar' },
    { sr: 12, composition: 'Member', name: 'Mr. Makrand Churi', designation: 'Agro Consultant' },
  ],
  'A.Y. 2023-24': [
    { sr: 1, composition: 'Chairperson', name: 'Dr. Vinita Gaikwad', designation: 'Director, TIMSCDR' },
    { sr: 2, composition: 'Member', name: 'Dr. Padma Mishra', designation: 'Assistant Professor, TIMSCDR' },
    { sr: 3, composition: 'Member', name: 'Mr. Shirshendu Maitra', designation: 'Assistant Professor, TIMSCDR' },
    { sr: 4, composition: 'Member', name: 'Dr. Seema Bansode Gokhe', designation: 'Prof. & Head – PSM Dept., LTMMC & LTMGH' },
    { sr: 5, composition: 'Member', name: 'Mr. Dinesh Kumar Singh', designation: 'TCS Innovation Lab' },
    { sr: 6, composition: 'Member', name: 'Dr. Mukesh Gupta', designation: "Founder, Le'Nest Hospital" },
    { sr: 7, composition: 'Member', name: 'Dr. S. Rajeshwaran', designation: 'DMI – Development Management Institute, Patna' },
    { sr: 8, composition: 'Member', name: 'Mr. Makrand Churi', designation: 'Agro Consultant' },
    { sr: 9, composition: 'Member', name: 'Mr. V. N. Datta', designation: 'Development and Quality Assurance Officer' },
  ],
  'A.Y. 2022-23': [
    { sr: 1, composition: 'Chairperson', name: 'Dr. Vinita Gaikwad', designation: 'Director, TIMSCDR' },
    { sr: 2, composition: 'Member', name: 'Dr. Pankaj Mudholklar', designation: 'Associate Professor, TIMSCDR' },
    { sr: 3, composition: 'Member', name: 'Mr. Shirshendu Maitra', designation: 'Assistant Professor, TIMSCDR' },
    { sr: 4, composition: 'Member', name: 'Dr. Seema Bansode Gokhe', designation: 'Prof. & Head – PSM Dept., LTMMC & LTMGH' },
    { sr: 5, composition: 'Member', name: 'Mr. Dinesh Kumar Singh', designation: 'TCS Innovation Lab' },
    { sr: 6, composition: 'Member', name: 'Dr. Gajanan Velhal', designation: 'Professor & Head, Dept of Community Medicine' },
    { sr: 7, composition: 'Member', name: 'Dr. S. Rajeshwaran', designation: 'DMI – Patna' },
    { sr: 8, composition: 'Member', name: 'Mr. Manohar Khake', designation: 'Agro Consultant' },
    { sr: 9, composition: 'Member', name: 'Mr. V. N. Datta', designation: 'Development and Quality Assurance Officer' },
  ],
  'A.Y. 2021-22': [
    { sr: 1, composition: 'Chairperson', name: 'Dr. Vinita Gaikwad', designation: 'Director, TIMSCDR' },
    { sr: 2, composition: 'Member', name: 'Dr. Pankaj Mudholkar', designation: 'Associate Professor, TIMSCDR' },
    { sr: 3, composition: 'Member', name: 'Mr. Shirshendu Maitra', designation: 'Assistant Professor, TIMSCDR' },
    { sr: 4, composition: 'Member', name: 'Dr. Seema Bansode Gokhe', designation: 'Prof. & Head – PSM Dept., LTMMC & LTMGH' },
    { sr: 5, composition: 'Member', name: 'Mr. Dinesh Kumar Singh', designation: 'TCS Innovation Lab' },
    { sr: 6, composition: 'Member', name: 'Dr. Gajanan Velhal', designation: 'Professor & Head, Dept of Community Medicine' },
    { sr: 7, composition: 'Member', name: 'Dr. Rajeshwaran Selvarajan', designation: 'Professor, DMI – Patna' },
    { sr: 8, composition: 'Member', name: 'Mr. Manohar Kahake', designation: 'Agro Consultant' },
    { sr: 9, composition: '—', name: 'Mr. V. N. Datta', designation: 'Advisor, TEG' },
  ],
};

const fundedProjectsData = [
  { sr: 1, year: '2025', title: 'AICTE Sponsored National Conference on Leveraging Information Technology for Sustainability in Agriculture & Healthcare – Viksit Bharat', investigators: 'TIMSCDR', funding: 'AICTE Grants for Organizing Conference (GOC) F.No. 67-5/IDC/GOC/P-2/2024-25/B Grant for Organizing Conference Team – Institute Development Cell, All India Council for Technical Education, New Delhi', funds: 'Selected for 2 Lakh Grant' },
  { sr: 2, year: '2025', title: 'AI–ML Based Animation App for Measuring Attention Level of the Learners and Re-Capturing Attention Using Upanishad Principles', investigators: 'PI – Dr. Ashwini Renavikar\nCo-Investigator – Dr. Rekha Singh', funding: 'AICTE, IKS Research Project', funds: 'Under Evaluation' },
  { sr: 3, year: '2025', title: 'Puppetry – A Traditional Art Form as a Strategic Tool to Cultivate Collaborative Leadership and Problem-Solving Skills in Management Education', investigators: 'PI – Dr. Rekha Singh\nCo-Investigator – Dr. Ashwini Renavikar', funding: 'AICTE, IKS Research Project', funds: 'Under Evaluation' },
  { sr: 4, year: '2024', title: 'Intelligent Machine Learning Solutions for Reducing Pesticide Application, Enhancing Wheat Crop Health, and Controlling Carcinogenic Effects on Human Health', investigators: 'PI – Dr. Padma Mishra\nCo-Investigator – Mr. Shirshendu Maitra, Ms. Rashmi Vipat, Ms. Rupali Jadhav\nGroup Members – Dr. Padma Mishra, Mr. Shirshendu Maitra, Ms. Rashmi Vipat, Ms. Rupali Jadhav', funding: 'Indian Council of Social Science Research (ICSSR) Climate Smart Agriculture', funds: 'Under Evaluation' },
  { sr: 5, year: '2024', title: 'Analytical Study on Impact of Electric Vehicles on Environment, Based on Eco-Scores – A Machine Learning Model Based Approach', investigators: 'PI – Dr. Shiksha Dubey\nCo-Investigator – Dr. Ashwini Renavikar\nGroup Members – Dr. Shiksha Dubey, Dr. Ashwini Renavikar, Mr. Shubham Mishra', funding: 'Indian Council of Social Science Research (ICSSR) Public Policy Analysis and Impact Evaluation', funds: 'Under Evaluation' },
  { sr: 6, year: '2024', title: 'Integrated mobile App and Soil Organic Carbon Detection Kit (SOCDK) for Soil Carbon Assessment', investigators: 'PI- Dr. Vinita Gaikwad, Director, TIMSCDR\nCo-Investigator – Ms. Anamika Dhawan, Asst. Professor, TIMSCDR\nDr. Padma Mishra, Asst. Professor, TIMSCDR\nMs. Shweta Waghmare, Asst. Professor, TIMSCDR', funding: 'UBA under Sustainable Agriculture System', funds: 'Under Evaluation' },
  { sr: 7, year: '2024', title: 'Leveraging Information Technology for Women Empowerment through Literacy for Rural Livelihood and Entrepreneurship Development in tribal Women in Sange Village, Palghar, Maharashtra', investigators: 'PI : Dr. Vinita Gaikwad, Director, TIMSCDR\nCo PI: Anamika Dhawan, Alifiya Shaikh, Shweta Waghmare, Thara C', funding: 'UBA under Sustainable Agriculture System', funds: 'Under Evaluation' },
  { sr: 8, year: '2023', title: 'Use of Mobile App for Digitization and Analysis of Soil Organic Carbon (SOC) level in agricultural farm tested using Soil Organic Carbon Detection Kit(SOCDK)', investigators: 'PI-Dr. Vinita Gaikwad, Director, TIMSCDR\nCo-Investigator – Ms. Anamika Dawan, Asst. Professor, TIMSCDR\nMs. Shweta Waghmare, Asst. Professor, TIMSCDR', funding: 'UBA under Technology Development', funds: 'Under Evaluation' },
  { sr: 9, year: '2022', title: 'Smart Air Fertigation (SAF) without using Fertilizers through Air Irrigation for Sustainable Agriculture', investigators: 'Dr. Vinita Gaikwad, Director, TIMSCDR\nMr. Pankaj Mudholkar, Asst. Professor, TIMSCDR', funding: 'Department of Science & Technology (DST), Government of India', funds: 'Under Processing' },
  { sr: 10, year: '2021', title: 'IoT based Crowd Detection System in City Buses', investigators: 'Mr. Pankaj Mudholkar, Asst. Professor, TIMSCDR\nMs. Megha Mudholkar, Asst. Professor, TIMSCDR', funding: 'Department of Science & Technology (DST), Government of India', funds: 'Under Processing' },
  { sr: 11, year: '2021', title: 'Memory Management through the process of allocating virtual storage for hiding information', investigators: 'Mr. Sachin More, Asst. Professor, TIMSCDR', funding: 'Department of Science & Technology (DST), Government of India', funds: 'Under Processing' },
  { sr: 12, year: '2020', title: 'Study of Awareness and Use of Information Technology by Farmers for effective Farming in the State of Maharashtra', investigators: 'Dr. Vinita Gaikwad, Director, TIMSCDR\nMr. Pankaj Mudholkar, Asst. Professor, TIMSCDR', funding: 'University of Mumbai', funds: '25000.00' },
  { sr: 13, year: '2020', title: 'Shishu Shiksha Data Science for Social Good', investigators: 'Mr. Shirshendu Maitra, Asst. Professor, TIMSCDR\nDr. Rajesh Kapur, Associate Professor, TIMSCDR', funding: 'University of Mumbai', funds: '25000.00' },
  { sr: 14, year: '2020', title: 'Artificial Intelligence (AI) and Natural Language Processing (NLP)', investigators: 'Ms. Sneha Rane, Asst. Professor, TIMSCDR\nDr. Rajesh Kapur, Associate Professor, TIMSCDR', funding: 'University of Mumbai', funds: '60000.00' },
  { sr: 15, year: '2019', title: 'Study of Agro-Waste Management by the Farmers in State of Maharashtra', investigators: 'Dr. Vinita Gaikwad, Director TIMSCDR\nMr. Pankaj Mudholkar, Asst. Professor, TIMSCDR', funding: '—', funds: '14000.00\n(Self-Funded)' },
  { sr: 16, year: '2018', title: 'Study of Role and Awareness of Information Technology in Agriculture in State of Maharashtra', investigators: 'Dr. Vinita Gaikwad, Director TIMSCDR\nMr. Pankaj Mudholkar, Asst. Professor, TIMSCDR', funding: 'Stelcore Management Services Private Ltd.', funds: '50000.00' },
  { sr: 17, year: '2018', title: 'Study of impact of Nutrition on Oral Health of college students and the role of Information Technology to control and enhance Oral Health', investigators: 'Dr. Vinita Gaikwad, Director TIMSCDR\nMr. Pankaj Mudholkar, Asst. Professor, TIMSCDR', funding: 'MGMDCH, Kamothe, Navi Mumbai and Lupin Ltd.', funds: '21000.00\n(Self-Funded)' },
  { sr: 18, year: '2017', title: 'Study of Role of Information Technology in Research by Dentists in the Dental Colleges in Mumbai', investigators: 'Dr. Vinita Gaikwad, Director TIMSCDR\nMr. Pankaj Mudholkar, Asst. Professor, TIMSCDR', funding: 'MGMDCH, Kamothe, Navi Mumbai', funds: '4000.00\n(Self-Funded)' },
  { sr: 19, year: '2017', title: 'Study of Role and Use of Information Technology in Clinical Research in the Medical Colleges in Mumbai', investigators: 'Dr. Vinita Gaikwad, Director TIMSCDR\nMr. Pankaj Mudholkar, Asst. Professor, TIMSCDR', funding: 'Lokanya Tilak Municipal General Hospital and Medical College, Sion, Mumbai', funds: '4000.00\n(Self-Funded)' },
  { sr: 20, year: '2017', title: 'Study of Adoption and Implementation of Information Technology in Industrial Research in Metropolitan City', investigators: 'Ms. Sonu Gupta, Asst. Professor, TIMSCDR\nMs. Sonam Pareek, Asst. Professor, TIMSCDR\nMs. Priya Sinha, Asst. Professor, TIMSCDR', funding: '—', funds: '4000.00\n(Self-Funded)' },
  { sr: 21, year: '2017', title: 'Study of Use of Information Technology for Research in Basic Sciences', investigators: 'Mr. Shirshendu Maitra, Asst. Professor, TIMSCDR\nMs. Aprajita Singh, Asst. Professor, TIMSCDR\nMs. Rupali Jadhav, Asst. Professor, TIMSCDR\nMs. Rashmi Vipat, Asst. Professor, TIMSCDR', funding: '—', funds: '3000.00\n(Self-Funded)' },
  { sr: 22, year: '2016', title: 'Study of Awareness and Use of Information Technology amongst Healthcare Practitioners in Tertiary Healthcare Hospital in Metropolitan city', investigators: 'Dr. Vinita Gaikwad, Director TIMSCDR\nMr. Pankaj Mudholkar, Asst. Professor, TIMSCDR', funding: 'Lokmanya Tilak Municipal General Hospital and Medical College, Sion, Mumbai', funds: '25000.00\n(Self-Funded)' },
  { sr: 23, year: '2016', title: 'Assessment of Awareness and Use of Information Technology by Healthcare Practitioners for providing Better Healthcare in Mumbai City', investigators: 'Dr. Vinita Gaikwad, Director TIMSCDR\nMr. Pankaj Mudholkar, Asst. Professor, TIMSCDR', funding: 'Seth GS Medical College & Hospital, Mumbai', funds: '25000.00\n(Self-Funded)' }
];

const archiveData = {
  projects: [
    { year: 'A.Y. 2024-25', url: '/pdf/RD/Project/A.Y. 2024-25.pdf' },
    { year: 'A.Y. 2023-24', url: '/pdf/RD/Project/A.Y. 2023-24.pdf' },
  ],
  publications: [
    { year: 'A.Y. 2024-25', url: '/pdf/RD/Publications/A.Y. 2024-25 2.pdf' },
    { year: 'A.Y. 2023-24', url: '/pdf/RD/Publications/A.Y. 2023-24.pdf' },
    { year: 'A.Y. 2022-23', url: '/pdf/RD/Publications/A.Y. 2022-23.pdf' },
    { year: 'A.Y. 2021-22', url: '/pdf/RD/Publications/A.Y. 2021-22.pdf' },
    { year: 'A.Y. 2020-21', url: '/pdf/RD/Publications/A.Y. 2020-21 (1).pdf' },
    { year: 'A.Y. 2019-20', url: '/pdf/RD/Publications/A.Y. 2019-20.pdf' },
    { year: 'A.Y. 2018-19', url: '/pdf/RD/Publications/A.Y. 2018-19.pdf' },
    { year: 'A.Y. 2017-18', url: '/pdf/RD/Publications/A.Y. 2017-18.pdf' },
    { year: 'A.Y. 2016-17', url: '/pdf/RD/Publications/A.Y. 2016-17.pdf' },
    { year: 'A.Y. 2015-16', url: '/pdf/RD/Publications/A.Y. 2015-16.pdf' },
  ],
  conferences: [
    { year: 'A.Y. 2024-25', url: '/pdf/RD/Conferences/conferences-2024-25.pdf' },
    { year: 'A.Y. 2023-24', url: '/pdf/RD/Conferences/conferences-2023-24.pdf' },
    { year: 'A.Y. 2022-23', url: '/pdf/RD/Conferences/A.Y. 2022-23 2.pdf' },
    { year: 'A.Y. 2021-22', url: '/pdf/RD/Conferences/A.Y. 2021-22 2.pdf' },
    { year: 'A.Y. 2020-21', url: '/pdf/RD/Conferences/A.Y. 2020-21 2.pdf' },
    { year: 'A.Y. 2019-20', url: '/pdf/RD/Conferences/A.Y. 2019-20 2.pdf' },
    { year: 'A.Y. 2018-19', url: '/pdf/RD/Conferences/A.Y. 2018-19 2.pdf' },
    { year: 'A.Y. 2017-18', url: '/pdf/RD/Conferences/A.Y. 2017-18 2.pdf' },
    { year: 'A.Y. 2016-17', url: '/pdf/RD/Conferences/A.Y. 2016-17 2.pdf' },
    { year: 'A.Y. 2015-16', url: '/pdf/RD/Conferences/A.Y. 2015-16 2.pdf' },
  ]
};

const years = Object.keys(committeeData);

const ResearchCell = () => {
  const [activeYear, setActiveYear] = useState('A.Y. 2025-26');

  return (
    <>
      <Navbar />
      <CTAButton />

      <div className="rc-page-wrapper">
        <PageHeader
          title="Research Cell"
          crumbs={[
            { label: "Home", href: "/" },
            { label: "Research Cell" },
          ]}
        />

        <div className="rc-main-container">

          {/* ABOUT R&D SECTION */}
          <div className="rc-about-layout">
            <div className="rc-about-text">
              <h2>Research and Development</h2>
              <p>
                Research and Development (R&D) at TIMSCDR is responsible for promoting a robust research culture within the Institute. As one of the top MCA colleges in Mumbai, TIMSCDR engages in investigative activities aimed at making discoveries that can lead to the development of new products or procedures, or the improvement of existing ones. Our R&D efforts are a means by which the Institute can achieve future growth by developing innovative products or processes to enhance and expand operations.
              </p>
              <p>
                TIMSCDR aims to conduct research to meet the corporate demands properly and promptly and to address their needs appropriately. TIMSCDR has a full fledged research team where researchers can give full play to their creativity, ensuring accountability for the research projects undertaken.
              </p>
              <p>
                TIMSCDR is pursuing interdisciplinary research work in the domains of Agriculture and Medicine (Healthcare) in association with renowned Institutes like KEM Hospital and Sion Hospital (LTMGH & LTMMC) and professional bodies – MACCIA (Maharashtra Chamber of Commerce, Industry & Agriculture) and AMC (The Association of Medical Consultants).
              </p>
            </div>

            <div className="rc-about-stats">
              <div className="rc-stat-card">
                <div className="rc-stat-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line></svg></div>
                <div className="rc-stat-info">
                  <h3>Top MCA</h3>
                  <p>Institutes in Mumbai</p>
                </div>
              </div>
              <div className="rc-stat-card">
                <div className="rc-stat-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg></div>
                <div className="rc-stat-info">
                  <h3>Interdisciplinary</h3>
                  <p>Agro & Healthcare Focus</p>
                </div>
              </div>
              <div className="rc-stat-card">
                <div className="rc-stat-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg></div>
                <div className="rc-stat-info">
                  <h3>MACCIA & AMC</h3>
                  <p>Professional Tie-ups</p>
                </div>
              </div>
              <div className="rc-stat-card">
                <div className="rc-stat-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg></div>
                <div className="rc-stat-info">
                  <h3>Corporate</h3>
                  <p>Demand Driven Research</p>
                </div>
              </div>
            </div>
          </div>

          {/* MAJOR FOCUS & OBJECTIVES SECTION */}
          <div className="rc-focus-functions-layout">
            <div className="rc-block-card">
              <h2 className="rc-block-title">Major Focus of Research Cell</h2>
              <div className="rc-focus-list">
                <div className="rc-focus-item">
                  <div className="rc-focus-circle-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                  </div>
                  <div>
                    <h4>Interdisciplinary Focus</h4>
                    <p>Pursuing research work in domains of Agriculture and Medicine (Healthcare) with renowned institutes.</p>
                  </div>
                </div>

                <div className="rc-focus-item">
                  <div className="rc-focus-circle-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                  </div>
                  <div>
                    <h4>Funded Projects</h4>
                    <p>Acquiring and working actively on Funded Research Projects to address industrial needs appropriately.</p>
                  </div>
                </div>

                <div className="rc-focus-item">
                  <div className="rc-focus-circle-icon">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path></svg>
                  </div>
                  <div>
                    <h4>Global Network</h4>
                    <p>Developing interdisciplinary networks with industry, government, professionals and experts for research collaborations.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="rc-block-card">
              <h2 className="rc-block-title">Objectives / Role</h2>
              <p className="rc-objectives-subtitle">Thakur Institute of Management Studies Career Development & Research (TIMSCDR) conducts R&D activities under the Research Cell. The Research Cell has the following objectives:</p>
              <ul className="rc-functions-list">
                <li>
                  <div className="rc-func-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg></div>
                  <span>To encourage Research culture amongst the Students and Faculty of the Institute by organizing and attending Conferences and Workshops, publishing research papers in UGC recognized Journals and peer reviewed Journals with high impact factor.</span>
                </li>
                <li>
                  <div className="rc-func-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg></div>
                  <span>Acquiring and working on Funded Research Projects.</span>
                </li>
                <li>
                  <div className="rc-func-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg></div>
                  <span>To perform research in the selected domains of Medicine and Agriculture.</span>
                </li>
                <li>
                  <div className="rc-func-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg></div>
                  <span>To study the role of Information Technology applications in Medicine and Agriculture but not limited to other domains.</span>
                </li>
                <li>
                  <div className="rc-func-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle></svg></div>
                  <span>To develop interdisciplinary network with industry, government, professionals and experts from research fields for research collaborations.</span>
                </li>
              </ul>
            </div>
          </div>

          {/* MEMBERS TABLE SECTION */}
          <div className="rc-table-container">
            <h2 className="rc-table-main-title">Research Committee Members at TIMSCDR</h2>
            <p className="rc-table-description">The Research Committee meets twice in the year and is instrumental in providing inputs for enhancement of Research in the Institute. The Research Cell at TIMSCDR has a Research Committee comprising of experts from inter-disciplinary domains.</p>

            <div className="rc-table-header-controls">
              <div className="rc-tabs-wrapper">
                {years.map(year => (
                  <button
                    key={year}
                    className={`rc-tab-btn ${activeYear === year ? 'active' : ''}`}
                    onClick={() => setActiveYear(year)}
                  >
                    {year}
                  </button>
                ))}
              </div>
              <div className="rc-total-members">
                Total Members: {committeeData[activeYear].length}
              </div>
            </div>

            <div className="rc-table-wrapper">
              <table className="rc-data-table">
                <thead>
                  <tr>
                    <th style={{ width: '80px' }}>SR. NO.</th>
                    <th>COMPOSITION</th>
                    <th>NAME OF MEMBER</th>
                    <th>DESIGNATION</th>
                  </tr>
                </thead>
                <tbody>
                  {committeeData[activeYear].map((row, idx) => (
                    <tr key={idx}>
                      <td>{row.sr}</td>
                      <td>{row.composition}</td>
                      <td className="fw-500">{row.name}</td>
                      <td>{row.designation}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* FUNDED RESEARCH PROJECTS SECTION */}
          <div className="rc-table-container rc-projects-margin">
            <h2 className="rc-table-main-title">Funded Research Projects</h2>
            <p className="rc-table-description">
              TIMSCDR has a fully fledged research team where researchers can give full play to their creativity, ensuring accountability for any research projects for the various sectors. The Research Cell of TIMSCDR is responsible for promoting partnerships and cooperation with various industries from allied domains such as Healthcare, Agriculture, Information Technology etc.
            </p>
            <p className="rc-table-description">
              The research work is funded by both the Institute as well as Industry. Some of the research projects carried out at TIMSCDR are:
            </p>

            <div className="rc-table-wrapper">
              <table className="rc-data-table rc-dense-table">
                <thead>
                  <tr>
                    <th style={{ width: '60px' }}>SR. NO.</th>
                    <th style={{ width: '80px' }}>YEAR</th>
                    <th style={{ width: '35%' }}>NAME OF THE PROJECT</th>
                    <th style={{ width: '25%' }}>NAME OF THE PRINCIPAL INVESTIGATOR / CO-INVESTIGATOR</th>
                    <th style={{ width: '25%' }}>NAME OF THE FUNDING AGENCY / COLLABORATION</th>
                    <th>FUNDS (IN INR)</th>
                  </tr>
                </thead>
                <tbody>
                  {fundedProjectsData.map((project, idx) => (
                    <tr key={idx}>
                      <td>{project.sr}</td>
                      <td>{project.year}</td>
                      <td className="fw-500">{project.title}</td>
                      <td className="rc-pre-line">{project.investigators}</td>
                      <td>{project.funding}</td>
                      <td className="rc-pre-line fw-500">{project.funds}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* ARCHIVES / PUBLICATIONS SECTION */}
          <div className="rc-archives-section">
            <div className="rc-archives-header">
              <div className="rc-arch-title-wrapper">
                <svg viewBox="0 0 24 24" fill="none" stroke="#5865F2" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                <h2>Research Projects, Journals & Conferences</h2>
              </div>
            </div>

            <div className="rc-archives-flex-grid">
              {/* Projects Category */}
              <div className="rc-archive-column">
                <h3 className="rc-category-title">Faculty Research Work / Projects</h3>
                <div className="rc-cert-cards-vertical">
                  {archiveData.projects.map((item, i) => (
                    <a 
                      href={item.url} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="rc-cert-card-mini" 
                      key={i}
                      style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
                    >
                      <div className="rc-cert-info">
                        <h4>Research Projects</h4>
                        <span className="rc-cert-year">{item.year}</span>
                      </div>
                      <div className="rc-download-icon-btn">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Journals Category */}
              <div className="rc-archive-column">
                <h3 className="rc-category-title">Journals</h3>
                <div className="rc-cert-cards-vertical rc-scrollable-col">
                  {archiveData.publications.map((item, i) => (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rc-cert-card-mini"
                      key={i}
                      style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
                    >
                      <div className="rc-cert-info">
                        <h4>Publications</h4>
                        <span className="rc-cert-year">{item.year}</span>
                      </div>
                      <div className="rc-download-icon-btn">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

              {/* Conferences Category */}
              <div className="rc-archive-column">
                <h3 className="rc-category-title">Conferences</h3>
                <div className="rc-cert-cards-vertical rc-scrollable-col">
                  {archiveData.conferences.map((item, i) => (
                    <a
                      href={item.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="rc-cert-card-mini"
                      key={i}
                      style={{ textDecoration: 'none', color: 'inherit', display: 'flex' }}
                    >
                      <div className="rc-cert-info">
                        <h4>Conference Proceedings</h4>
                        <span className="rc-cert-year">{item.year}</span>
                      </div>
                      <div className="rc-download-icon-btn">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
                      </div>
                    </a>
                  ))}
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>

      <Footer />
    </>
  );
};

export default ResearchCell;